// Utils
import { currencySymbolMap } from '@app/account/utils';

// Hooks
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

// Redux
import { getCurrency } from '../models/pricing';

// Types
import type { Currency } from '@app/account/types';

export const useCurrencyValue = (): { currency: Currency; symbol: string } => {
    const currency = useSelector(getCurrency);

    return useMemo(() => {
        const symbol = currencySymbolMap[currency];

        return {
            currency,
            symbol,
        };
    }, [currency]);
};
